import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../App";
import Sidebar from "../components/Sidebar";
import { Funnel } from "@phosphor-icons/react";

const STAGE_COLORS = {
  prospect: "#475569",
  negotiation: "#F59E0B",
  proposal: "#002FA7",
  closed_won: "#10B981",
  closed_lost: "#DC2626"
};

const SalesFunnel = ({ user, logout }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/crm/sales-funnel`);
      setData(res.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetchData(); }, [fetchData]);

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar user={user} logout={logout} />
      <div className="flex-1 ml-64 p-8">
        <h1 className="text-4xl sm:text-5xl tracking-tighter leading-none font-bold mb-2" style={{fontFamily: 'Outfit, sans-serif'}}>Sales Funnel</h1>
        <p className="text-base text-slate-700 mb-8">Visual pipeline conversion analysis</p>

        {loading ? <div className="flex justify-center py-20"><div className="loading-spinner"></div></div> : data && (
          <>
            <div className="bg-white border border-slate-200 rounded-none shadow-sm p-8 mb-8">
              <div className="flex items-center gap-3 mb-6">
                <Funnel size={28} weight="duotone" className="text-[#002FA7]" />
                <h3 className="text-xl font-semibold" style={{fontFamily: 'Outfit, sans-serif'}}>Pipeline Funnel ({data.total_deals} total deals)</h3>
              </div>

              <div className="space-y-4">
                {data.funnel.map((stage) => {
                  const maxWidth = 100;
                  const width = Math.max(stage.percentage, 5);
                  return (
                    <div key={stage.stage} data-testid={`funnel-${stage.stage}`} className="flex items-center gap-4">
                      <div className="w-32 text-right">
                        <p className="text-sm font-semibold capitalize">{stage.stage.replace('_', ' ')}</p>
                      </div>
                      <div className="flex-1">
                        <div className="relative">
                          <div className="h-12 rounded-none flex items-center px-4 transition-all duration-500"
                            style={{width: `${width}%`, backgroundColor: STAGE_COLORS[stage.stage] || '#475569', minWidth: '80px'}}>
                            <span className="text-white text-sm font-bold">{stage.count} deals</span>
                          </div>
                        </div>
                      </div>
                      <div className="w-40 text-right">
                        <span className="text-sm font-bold" style={{color: STAGE_COLORS[stage.stage]}}>₹{stage.value.toLocaleString('en-IN')}</span>
                        <span className="text-xs text-slate-400 ml-2">({stage.percentage}%)</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Conversion rates */}
            <div className="grid grid-cols-4 gap-6">
              {data.funnel.slice(0, 4).map((stage, idx) => {
                const next = data.funnel[idx + 1];
                const convRate = next && stage.count > 0 ? ((next.count / stage.count) * 100).toFixed(1) : 'N/A';
                return (
                  <div key={stage.stage} className="bg-white border border-slate-200 rounded-none shadow-sm p-6 text-center">
                    <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-2 capitalize">{stage.stage.replace('_', ' ')} to {next ? next.stage.replace('_', ' ') : 'End'}</p>
                    <p className="text-3xl font-bold" style={{fontFamily: 'Outfit, sans-serif', color: STAGE_COLORS[stage.stage]}}>{convRate}{convRate !== 'N/A' ? '%' : ''}</p>
                    <p className="text-xs text-slate-500 mt-1">Conversion Rate</p>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SalesFunnel;
